import React, {useMemo, useState} from 'react';
import {Formik} from 'formik';
import {isEqual} from 'lodash';
import {useRegistrationDataUIContext} from '../RegistrationDataUIContext';
import moment from 'moment';
import * as actions from '../../_redux/registrationDataActions';
import {generateExcelFile} from '../../../_common/utils/excel';
import {formatPhoneNumberForExcel, countdown} from '../../../../../utils';
import {useDispatch} from 'react-redux';
import ButtonExportToExcel from '../../../_common/components/ButtonExportToExcel';
import {FilterFromDate, FilterToDate} from '../../../_common/components/FilterDateRange';
import FiltersBar from '../../../_common/components/FiltersBar';
import {headersRegistrationData} from '../../../_common/constants/exportedFilesHeaders';
import {regDataHeader} from '../../../_common/constants/exportedFilesMainHeaders';
import {getLastCompletedStepLabel} from '../../../_common/utils/getLastCompletedStepLabel';

const prepareFilter = (queryParams, values) => {
  const {fromDate, toDate} = values;
  const newQueryParams = {...queryParams};
  const filter = {};
  filter.fromDate = moment(fromDate).format('YYYY-MM-DD');
  filter.toDate = moment(toDate).format('YYYY-MM-DD');
  return {...newQueryParams, ...filter};
};

export function RegistrationDataFilter() {
  const dispatch = useDispatch();
  const regDataUIContext = useRegistrationDataUIContext();
  const regDataUIProps = useMemo(() => {
    return {
      queryParams: regDataUIContext.queryParams,
      setQueryParams: regDataUIContext.setQueryParams,
    };
  }, [regDataUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(regDataUIProps.queryParams, values);
    if (!isEqual(newQueryParams, regDataUIProps.queryParams)) {
      regDataUIProps.setQueryParams(newQueryParams);
    }
  };

  const qs = new URLSearchParams(window.location.search);
  const weekAgo = moment().subtract(1, 'w');
  const today = moment();
  const fromDate = qs.get('fromDate') || weekAgo.format('YYYY-MM-DD');
  const toDate = qs.get('toDate') || today.add(1, 'days').format('YYYY-MM-DD');

  const newQueryParams = {...regDataUIProps.queryParams, fromDate, toDate};
  if (!isEqual(newQueryParams, regDataUIProps.queryParams)) {
    regDataUIProps.setQueryParams(newQueryParams);
  }

  const [loading, setLoading] = useState(false);
  const exportRegistrationDataFileFunc = () => {
    setLoading(true);
    dispatch(actions.exportRegistrationDataFileAction(regDataUIProps.queryParams))
      .then(prepareDataForExcel)
      .then((data) => {
        generateExcelFile(data, 'Registration data.xlsx', regDataHeader);
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };
  const prepareDataForExcel = data => {
    return data.map((item, index) => {
      const {
        profile,
        email,
        cameFrom,
        cameFromText,
        practiceArea,
        lastCompletedStep,
        createdAt,
        lastUpdate,
        agentId,
        tamalId,
      } = item;
      const firstName = (profile && profile.firstName) ? profile.firstName : '';
      const lastName = (profile && profile.lastName) ? profile.lastName : '';
      const fullName = `${firstName} ${lastName}`;
      const phone = (profile && profile.phone) ? profile.phone : '';
      const emailAddress = email ? email : '';
      const cameFromContent = cameFrom ? cameFrom : '';
      const lastCompletedStepLabel = getLastCompletedStepLabel(lastCompletedStep);
      const startDate = Date.parse(createdAt) / 1000;
      const lastDate = Date.parse(lastUpdate) / 1000;
      const range = (lastDate - startDate);
      const dateDifference = `${countdown(range)}`;
      const creationDate = `${createdAt.slice(8, 10)}-${createdAt.slice(5, 7)}-${createdAt.slice(0, 4)}  
       ${createdAt.slice(11, 16)}`;
      const agentIdNumber = agentId ? agentId : '';
      const tamalIdNumber = tamalId ? tamalId : '';

      return {
        [headersRegistrationData[0]]: index + 1,
        [headersRegistrationData[1]]: fullName,
        [headersRegistrationData[2]]: formatPhoneNumberForExcel(phone),
        [headersRegistrationData[3]]: emailAddress,
        [headersRegistrationData[4]]: cameFromContent === 'אחר' ? cameFromText : cameFromContent,
        [headersRegistrationData[5]]: practiceArea,
        [headersRegistrationData[6]]: lastCompletedStepLabel,
        [headersRegistrationData[7]]: dateDifference,
        [headersRegistrationData[8]]: creationDate,
        [headersRegistrationData[9]]: agentIdNumber,
        [headersRegistrationData[10]]: tamalIdNumber,
      };
    });
  };

  const containerClassnames = 'w-200px position-relative my-1 px-3';

  return (
    <Formik
      initialValues={{fromDate, toDate}}
      onSubmit={(values) => applyFilter(values)}
      enableReinitialize={true}
    >
      {({values, ...formikProps}) => (
        <FiltersBar
          filters={
            <div className={'d-flex flex-wrap justify-content-center align-items-center mb-0 w-100'}>
              <FilterFromDate
                values={values}
                customClearDate={() => {
                  formikProps.setFieldValue('fromDate', moment(weekAgo).toDate());
                }}
                containerStyles={containerClassnames}
                {...formikProps}
              />
              <FilterToDate
                values={values}
                customClearDate={() => {
                  formikProps.setFieldValue('toDate', moment(today).toDate());
                }}
                containerStyles={containerClassnames}
                {...formikProps}
              />
            </div>
          }
          buttons={
            <ButtonExportToExcel
              exportFunc={exportRegistrationDataFileFunc}
              loading={loading}
            />
          }
        />
      )}
    </Formik>
  );
}
